<!-- 产品供求推荐：图片（左）+标题+时间 -->
<template>
<div class="info-block">
  <router-link class="info-block-a" :to="'/sggq/ghDetail/1/'+info.id" :title="info.title" v-bind:style="{backgroundImage:'url('+imgRootPath+info.image+')'}" target="_blank" >
    <div class="title">{{info.name.length>titleLength?(info.name.substring(0,titleLength)+'...'):info.name}}</div>
    <div class="price">￥{{info.price}}/{{info.unit}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'InfoBlock14',
  props: {
    info: {
      type: Object,
      default: {}
    },
    infoIndex: {
      type: Number,
      default: 0
    },
    infoPre: {
      type: Object,
      default: function(){return {}}
    },
    infoNext: {
      type: Object,
      default: function(){return {}}
    },
    titleLength:{
      type:Number,
      default:10
    },
    labelLength:{
      type:Number,
      default:28
    }
  },
  data() {
    return {
      imgRootPath:this.Global.resourceDomain,
    }
  },
  methods:{
    detailView(){

    },
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:border-box;
  height:70px;
  width:100%;
  padding:0px 10px 0px 90px;
  margin-bottom:10px;
  border:1px solid #eee;
  background-color: #fff;
  background-size: 80px auto;
  background-repeat: no-repeat;
  background-position:0 center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid #eee;
  color:var(--color6);
  cursor:pointer;
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block .info-block-a:hover > .title{
  color:var(--color6);
}

.info-block-a .title{
  display:block;
  font-size:12px;
  font-weight:600;
  color:#282A2B;
  line-height:30px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

.info-block-a .price{
  display:block;
  padding-top:6px;
  font-size:12px;
  color:#9FA2A6;
  line-height:20px;
  color:#888;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoBlock14.vue